var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"standard"}},_vm._l((_vm.sports),function(sport){return _c('sport',{key:sport.id,attrs:{"sport":sport}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }